import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CheckIcon, XIcon } from 'lucide-react';
const rows = [{
  feature: '6 Tomos PROTORRENDA',
  base: true,
  combo: true
}, {
  feature: '4 Bonos Estratégicos',
  base: true,
  combo: true
}, {
  feature: 'Pelotón 10X',
  base: false,
  combo: true
}, {
  feature: 'Tácticas de Viento',
  base: false,
  combo: true
}, {
  feature: 'Posicionamiento en Pelotón',
  base: false,
  combo: true
}, {
  feature: 'Mentalidad de Competidor',
  base: false,
  combo: true
}];
function Check() {
  return <div className="w-8 h-8 rounded-md bg-green-500/20 flex items-center justify-center" role="img" aria-label="Incluido" data-id="element-208">
      <CheckIcon className="w-5 h-5 text-green-400" strokeWidth={3} aria-hidden="true" data-id="element-209" />
    </div>;
}
function Cross() {
  return <div className="w-8 h-8 rounded-md bg-red-500/15 flex items-center justify-center" role="img" aria-label="No incluido" data-id="element-210">
      <XIcon className="w-5 h-5 text-red-400" strokeWidth={3} aria-hidden="true" data-id="element-211" />
    </div>;
}
export function PackComparisonTable() {
  return <div className="px-4 bg-slate-950" data-id="element-212">
      <div className="max-w-2xl mx-auto" data-id="element-213">
        <FadeIn data-id="element-214">
          <div className="rounded-xl border border-slate-700/80 overflow-hidden" data-id="element-215">
            <table className="w-full" role="table" aria-label="Comparación de packs: Pack Base vs Base + Pelotón 10X" data-id="element-216">
              <thead data-id="element-217">
                <tr data-id="element-218">
                  <th scope="col" className="bg-slate-950 p-4 md:p-5 border-b border-slate-700/80 text-left" data-id="element-219">
                    <span className="sr-only" data-id="element-220">Característica</span>
                  </th>
                  <th scope="col" className="bg-slate-950 p-4 md:p-5 border-b border-l border-slate-700/80 text-center" data-id="element-221">
                    <span className="text-white font-black text-xs md:text-sm tracking-wider uppercase" data-id="element-222">
                      PACK
                      <br data-id="element-223" />
                      BASE
                    </span>
                  </th>
                  <th scope="col" className="bg-slate-900/70 p-4 md:p-5 border-b border-l border-slate-700/80 text-center" data-id="element-224">
                    <span className="text-green-400 font-black text-xs md:text-sm tracking-wider uppercase leading-tight" data-id="element-225">
                      BASE +<br data-id="element-226" />
                      PELOTÓN 10X
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-227">
                {rows.map((row, i) => <tr key={i} data-id="element-228">
                    <th scope="row" className={`${i % 2 === 0 ? 'bg-slate-900/40' : 'bg-slate-900/20'} p-4 md:p-5 border-b border-slate-700/50 text-left`} data-id="element-229">
                      <span className="text-slate-200 text-sm md:text-base font-medium" data-id="element-230">
                        {row.feature}
                      </span>
                    </th>
                    <td className={`${i % 2 === 0 ? 'bg-slate-900/40' : 'bg-slate-900/20'} p-4 md:p-5 border-b border-l border-slate-700/50 text-center`} data-id="element-231">
                      {row.base ? <Check data-id="element-232" /> : <Cross data-id="element-233" />}
                    </td>
                    <td className={`${i % 2 === 0 ? 'bg-slate-900/60' : 'bg-slate-900/40'} p-4 md:p-5 border-b border-l border-slate-700/50 text-center`} data-id="element-234">
                      {row.combo ? <Check data-id="element-235" /> : <Cross data-id="element-236" />}
                    </td>
                  </tr>)}
              </tbody>
              <tfoot data-id="element-237">
                <tr className="border-t border-slate-600" data-id="element-238">
                  <th scope="row" className="bg-slate-950 p-4 md:p-6 text-left" data-id="element-239">
                    <span className="text-white text-sm md:text-base font-black tracking-wide" data-id="element-240">
                      PRECIO
                    </span>
                  </th>
                  <td className="bg-slate-950 p-4 md:p-6 border-l border-slate-700/80 text-center" data-id="element-241">
                    <span className="text-white font-black text-lg md:text-2xl" data-id="element-242">
                      $19.990
                    </span>
                  </td>
                  <td className="bg-slate-900/70 p-4 md:p-6 border-l border-slate-700/80 text-center" data-id="element-243">
                    <span className="text-green-400 font-black text-lg md:text-2xl" data-id="element-244">
                      $29.990
                    </span>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </FadeIn>
      </div>
    </div>;
}